Vue.component('form-component', {
    data: function () {
        return {
            hasCaptcha: false,
            captchaExecuted: false,
            inputs: []
        }
    },
    components: {
        'vue-recaptcha': VueRecaptcha
    },
    mounted: function() {
        this.inputs = this.$el.querySelectorAll('.form__input');

        for (let i = 0, input; input = this.inputs[i]; i++) {
            input.addEventListener('input', e => {
                const value = e.target.value.trim();

                if (value) {
                    e.target.dataset.state = 'filled'
                } else {
                    e.target.dataset.state = ''
                }
            })
        }

        this.setLabels();
    },
    methods: {
        submit: function () {
            let form = this.$el;

            this.$validator.validateAll().then(result => {
                if (result) {
                    if (!this.hasCaptcha || this.captchaExecuted) {
                        this.$root.submitForm(form);
                    } else {
                        this.$refs.recaptcha.execute();
                    }
                }
            });
        },
        onCaptchaVerified: function () {
            this.captchaExecuted = true;
            this.submit();
        },
        setLabels: function () {
            // query selector for .form__valueWrapper
            let groups = document.querySelectorAll(".form__valueWrapper");

            // for loop through $groups
            for (let i = 0; i < groups.length; i++) {
                groups[i].parentNode.classList.add('form__label-active')
            }
        }
    },
});
